import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-footer',
  templateUrl: './modal-footer.component.html'
})
export class ModalFooterComponent implements OnInit {
  @Input() cancelText = 'キャンセル';
  @Input() excuteText?: string;
  @Input() disabled?: boolean;
  @Output() onCloseChange = new EventEmitter<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onClose(): void {
    this.router.navigate([{ outlets: { modal: null } }], {replaceUrl: true, queryParamsHandling: "preserve" });
    this.onCloseChange.emit();
  }
}
